import {HttpService} from "../../App/services/http";
import {IPurchaseItemsQuery, IPurchasesQuery} from "../interface/purchase";

export const GuestService = {
    getPurchase: (params: IPurchasesQuery) => HttpService.get('/api/purchase/orders/compressed/main', params),
    getItems: (params: IPurchaseItemsQuery) => HttpService.get(`/api/purchase/orders/compressed/${params.orderId}/lot/${params.lotId}/items`)
}